import {css} from "lit-element/lit-element.js";
export default css`@charset "UTF-8";
.wy-light :where(wy-chat), .wy-light :where(wy-files), .wy-light :where(wy-messenger), .wy-light :where(wy-posts), .wy-light :where(wy-portal), :host(.wy-light), :host .wy-light, ::slotted(.wy-light) {
  color-scheme: light;
  --wy-primary: var(--wy-primary-40, #006399);
  --wy-on-primary: var(--wy-white, #ffffff);
  --wy-primary-container: var(--wy-primary-90, #cde5ff);
  --wy-on-primary-container: var(--wy-primary-10, #001d32);
  --wy-secondary: var(--wy-secondary-40, #3b6a1c);
  --wy-on-secondary: var(--wy-white, #ffffff);
  --wy-secondary-container: var(--wy-secondary-90, #bbf294);
  --wy-on-secondary-container: var(--wy-secondary-10, #0a2100);
  --wy-tertiary: var(--wy-tertiary-40, #3b6a1c);
  --wy-on-tertiary: var(--wy-white, #ffffff);
  --wy-tertiary-container: var(--wy-tertiary-90, #bbf294);
  --wy-on-tertiary-container: var(--wy-tertiary-10, #0a2100);
  --wy-error: var(--wy-error-40, #ba1824);
  --wy-on-error: var(--wy-white, #ffffff);
  --wy-error-container: var(--wy-error-90, #ffdad7);
  --wy-on-error-container: var(--wy-error-10, #410004);
  --wy-warning: var(--wy-warning-70, #afb140);
  --wy-on-warning: var(--wy-black, #000000);
  --wy-warning-container: var(--wy-warning-90, #e7e971);
  --wy-on-warning-container: var(--wy-warning-10, #1c1d00);
  --wy-background: var(--wy-neutral-99, #fcfcff);
  --wy-on-background: var(--wy-neutral-10, #1a1c1e);
  --wy-surface: var(--wy-neutral-99, #fcfcff);
  --wy-on-surface: var(--wy-neutral-10, #1a1c1e);
  --wy-surface-variant: var(--wy-neutral-variant-90, #dee3eb);
  --wy-on-surface-variant: var(--wy-neutral-variant-30, #42474e);
  --wy-outline: var(--wy-neutral-variant-50, #72777e);
  --wy-outline-variant: var(--wy-neutral-variant-80, #c2c7ce);
  --wy-inverse-surface: var(--wy-neutral-20, #2f3033);
  --wy-on-inverse-surface: var(--wy-neutral-95, #f0f0f4);
  --wy-inverse-primary: var(--wy-primary-80, #95ccff);
  --wy-surface-1: var(--wy-surface-1-light, #f1f2f7);
  --wy-surface-2: var(--wy-surface-2-light, #eaedf3);
  --wy-surface-3: var(--wy-surface-3-light, #e3e7ee);
  --wy-surface-4: var(--wy-surface-4-light, #e1e6ed);
  --wy-surface-5: var(--wy-surface-5-light, #dce2ea);
  --wy-link: var(--wy-primary-40, #006399);
  --wy-blue: var(--wy-blue-light, #89a9fc);
  --wy-indigo: var(--wy-indigo-light, #9185de);
  --wy-purple: var(--wy-purple-light, #c675b7);
  --wy-pink: var(--wy-pink-light, #d57194);
  --wy-red: var(--wy-red-light, #db726c);
  --wy-orange: var(--wy-orange-light, #e89a3a);
  --wy-yellow: var(--wy-yellow-light, #afb140);
  --wy-green: var(--wy-green-light, #00a38b);
  --wy-teal: var(--wy-teal-light, #00a0a8);
  --wy-cyan: var(--wy-cyan-light, #0082a1);
  --wy-gray: var(--wy-gray-light, #76777a);
  --wy-presence-active: var(--wy-green-light, #00a38b);
  --wy-code-text: var(--wy-code-text-light, #3b3b3b);
  --wy-code-variable: var(--wy-code-variable-light, #001080);
  --wy-code-operator: var(--wy-code-operator-light, #000000);
  --wy-code-prolog: var(--wy-code-prolog-light, #000080);
  --wy-code-comment: var(--wy-code-comment-light, #008000);
  --wy-code-builtin: var(--wy-code-builtin-light, #0070C1);
  --wy-code-number: var(--wy-code-number-light, #098658);
  --wy-code-inserted: var(--wy-code-inserted-light, #098658);
  --wy-code-constant: var(--wy-code-constant-light, #811F3F);
  --wy-code-hexcode: var(--wy-code-hexcode-light, #811F3F);
  --wy-code-regex: var(--wy-code-regex-light, #811F3F);
  --wy-code-char: var(--wy-code-char-light, #811F3F);
  --wy-code-tag: var(--wy-code-tag-light, #800000);
  --wy-code-attr-name: var(--wy-code-attr-name-light, #E50000);
  --wy-code-selector: var(--wy-code-selector-light, #E50000);
  --wy-code-property: var(--wy-code-property-light, #E50000);
  --wy-code-deleted: var(--wy-code-deleted-light, #A31515);
  --wy-code-string: var(--wy-code-string-light, #A31515);
  --wy-code-changed: var(--wy-code-changed-light, #0451A5);
  --wy-code-punctuation: var(--wy-code-punctuation-light, #000000);
  --wy-code-function: var(--wy-code-function-light, #0000FF);
  --wy-code-keyword: var(--wy-code-keyword-light, #AF00DB);
  --wy-code-class-name: var(--wy-code-class-name-light, #267F99);
}

.wy-dark:not(.wy-light) :where(wy-chat), .wy-dark:not(.wy-light) :where(wy-files), .wy-dark:not(.wy-light) :where(wy-messenger), .wy-dark:not(.wy-light) :where(wy-posts), .wy-dark:not(.wy-light) :where(wy-portal), :host(.wy-dark:not(.wy-light)), :host .wy-dark:not(.wy-light), ::slotted(.wy-dark:not(.wy-light)) {
  color-scheme: dark;
  --wy-primary: var(--wy-primary-80, #95ccff);
  --wy-on-primary: var(--wy-primary-20, #003352);
  --wy-primary-container: var(--wy-primary-30, #004a75);
  --wy-on-primary-container: var(--wy-primary-90, #cde5ff);
  --wy-secondary: var(--wy-secondary-80, #a0d57b);
  --wy-on-secondary: var(--wy-secondary-20, #163800);
  --wy-secondary-container: var(--wy-secondary-30, #245103);
  --wy-on-secondary-container: var(--wy-secondary-90, #bbf294);
  --wy-tertiary: var(--wy-tertiary-80, #a0d57b);
  --wy-on-tertiary: var(--wy-tertiary-20, #163800);
  --wy-tertiary-container: var(--wy-tertiary-30, #245103);
  --wy-on-tertiary-container: var(--wy-tertiary-90, #bbf294);
  --wy-error: var(--wy-error-80, #ffb3ae);
  --wy-on-error: var(--wy-error-20, #68000b);
  --wy-error-container: var(--wy-error-30, #930014);
  --wy-on-error-container: var(--wy-error-90, #ffdad7);
  --wy-warning: var(--wy-warning-90, #e7e971);
  --wy-on-warning: var(--wy-warning-30, #484a00);
  --wy-warning-container: var(--wy-warning-50, #7a7c05);
  --wy-on-warning-container: var(--wy-warning-95, #f5f77d);
  --wy-background: var(--wy-neutral-10, #1a1c1e);
  --wy-on-background: var(--wy-neutral-90, #e2e2e5);
  --wy-surface: var(--wy-neutral-10, #1a1c1e);
  --wy-on-surface: var(--wy-neutral-90, #e2e2e5);
  --wy-surface-variant: var(--wy-neutral-variant-30, #42474e);
  --wy-on-surface-variant: var(--wy-neutral-variant-80, #c2c7ce);
  --wy-outline: var(--wy-neutral-variant-60, #8c9198);
  --wy-outline-variant: var(--wy-neutral-variant-30, #42474e);
  --wy-inverse-surface: var(--wy-neutral-90, #e2e2e5);
  --wy-on-inverse-surface: var(--wy-neutral-20, #2f3033);
  --wy-inverse-primary: var(--wy-primary-40, #006399);
  --wy-surface-1: var(--wy-surface-1-dark, #212427);
  --wy-surface-2: var(--wy-surface-2-dark, #25292d);
  --wy-surface-3: var(--wy-surface-3-dark, #292e33);
  --wy-surface-4: var(--wy-surface-4-dark, #2b3035);
  --wy-surface-5: var(--wy-surface-5-dark, #2d3338);
  --wy-link: var(--wy-primary-80, #95ccff);
  --wy-blue: var(--wy-blue-dark, #b1c5ff);
  --wy-indigo: var(--wy-indigo-dark, #9185de);
  --wy-purple: var(--wy-purple-dark, #e38fd3);
  --wy-pink: var(--wy-pink-dark, #f48bae);
  --wy-red: var(--wy-red-dark, #db726c);
  --wy-orange: var(--wy-orange-dark, #e89a3a);
  --wy-yellow: var(--wy-yellow-dark, #cacc58);
  --wy-green: var(--wy-green-dark, #00a38b);
  --wy-teal: var(--wy-teal-dark, #00a0a8);
  --wy-cyan: var(--wy-cyan-dark, #009dc3);
  --wy-gray: var(--wy-gray-dark, #909194);
  --wy-presence-active: var(--wy-green-dark, #00a38b);
  --wy-code-text: var(--wy-code-text-dark, #cccccc);
  --wy-code-variable: var(--wy-code-variable-dark, #9CDCFE);
  --wy-code-operator: var(--wy-code-operator-dark, #d4d4d4);
  --wy-code-prolog: var(--wy-code-prolog-dark, #569CD6);
  --wy-code-comment: var(--wy-code-comment-dark, #6a9955);
  --wy-code-builtin: var(--wy-code-builtin-dark, #4fc1ff);
  --wy-code-number: var(--wy-code-number-dark, #b5cea8);
  --wy-code-inserted: var(--wy-code-inserted-dark, #b5cea8);
  --wy-code-constant: var(--wy-code-constant-dark, #646695);
  --wy-code-hexcode: var(--wy-code-hexcode-dark, #646695);
  --wy-code-regex: var(--wy-code-regex-dark, #d16969);
  --wy-code-char: var(--wy-code-char-dark, #d16969);
  --wy-code-tag: var(--wy-code-tag-dark, #569cd6);
  --wy-code-attr-name: var(--wy-code-attr-name-dark, #9cdcfe);
  --wy-code-selector: var(--wy-code-selector-dark, #9cdcfe);
  --wy-code-property: var(--wy-code-property-dark, #9cdcfe);
  --wy-code-deleted: var(--wy-code-deleted-dark, #ce9178);
  --wy-code-string: var(--wy-code-string-dark, #ce9178);
  --wy-code-changed: var(--wy-code-changed-dark, #569cd6);
  --wy-code-punctuation: var(--wy-code-punctuation-dark, #D4D4D4);
  --wy-code-function: var(--wy-code-function-dark, #569cd6);
  --wy-code-keyword: var(--wy-code-keyword-dark, #C586C0);
  --wy-code-class-name: var(--wy-code-class-name-dark, #4ec9b0);
}

/*
 * INSTRUCTIONS:
 * - variables cannot reference themselves
 * - variables may reference other variables, but must ALWAYS have an explicit default fallback (since that variable may not exist in reality).
 * - The fallback value should be the same as any referenced variable
 */
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]) {
  box-sizing: border-box;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *::before, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *::after {
  box-sizing: inherit;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a) {
  text-decoration: var(--wy-link-decoration, none);
  color: var(--wy-link, var(--wy-primary-40, #006399));
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):hover, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):hover {
  text-decoration: var(--wy-link-hover-decoration, unset);
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):where(:not([href]):not([class])), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):where(:not([href]):not([class])):hover, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):where(:not([href]):not([class])), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):where(:not([href]):not([class])):hover {
  text-decoration: none;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(p), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(p) {
  margin-top: 0;
  margin-bottom: 1rem;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(label), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(label) {
  cursor: inherit;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"])[hidden], :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *[hidden] {
  display: none !important;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where([role=button]), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where([role=button]) {
  cursor: pointer;
}

.wy-scroll-y {
  overflow-y: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-height: 100%;
  scroll-padding-top: var(--wy-scrollbar-adjust-top, 0);
  scroll-padding-bottom: var(--wy-scrollbar-adjust-bottom, 0);
}
.wy-scroll-y:not(body) {
  -webkit-overflow-scrolling: touch;
}
.wy-scroll-y:not(.wy-scroll-x) {
  overflow-x: hidden;
  touch-action: pan-y;
}

.wy-scroll-x {
  overflow-x: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-width: 100%;
}
.wy-scroll-x:not(.wy-scroll-y) {
  overflow-y: hidden;
  touch-action: pan-x;
}

.wy-scrollbars.wy-scroll-y, .wy-scrollbars .wy-scroll-y {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
@supports (overflow-y: overlay) {
  .wy-scrollbars.wy-scroll-y, .wy-scrollbars .wy-scroll-y {
    overflow-y: overlay;
  }
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-track, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb:hover, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb:window-inactive, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-button:vertical:start:single-button, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-button:vertical:start:single-button {
  height: var(--wy-scrollbar-adjust-top, 0);
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-button:vertical:end:single-button, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-button:vertical:end:single-button {
  height: var(--wy-scrollbar-adjust-bottom, 0);
}

.wy-block-scroll {
  overflow: hidden !important;
}

.wy-scrollbar-detection {
  position: fixed;
  top: 0;
  left: 0;
  width: 8rem;
  height: 8rem;
  overflow: scroll;
  z-index: -99999;
  pointer-events: none;
  visibility: hidden;
}

.wy-appbars {
  backface-visibility: hidden;
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  background-color: var(--wy-component-background-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}
@supports (position: sticky) {
  .wy-appbars {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-appbars {
    backdrop-filter: blur(0.5rem);
  }
  .wy-appbars > .wy-appbar {
    backdrop-filter: none;
  }
}
.wy-appbars > .wy-appbar, .wy-appbars > .wy-toolbar {
  background-color: transparent;
  box-shadow: none;
}

.wy-appbar {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  display: grid;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
  height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  flex: 0 0 var(--wy-appbar-height, 3rem);
  grid-template-columns: minmax(2.5rem, max-content) minmax(0, max-content) minmax(2.5rem, max-content);
  column-gap: 0.5rem;
  line-height: var(--wy-line-height-base, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}
.wy-appbar .wy-badge {
  align-self: center;
}
.wy-appbar .wy-button {
  max-height: 2.5rem;
}

.wy-appbar-buttons, .wy-toolbar-buttons {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.wy-toolbar-buttons-last {
  margin-inline-start: auto;
}

.wy-appbar-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  color: inherit !important;
  user-select: none;
}
.wy-appbar-text a {
  color: inherit;
}
.wy-appbar-text a:hover {
  color: inherit;
}

.wy-appbar-text-trashed {
  text-decoration: line-through;
}

.wy-toolbars-bottom {
  position: absolute;
  z-index: 1030;
  bottom: calc(var(--wy-footerbar-height, 4rem) / 2);
  left: 0;
  right: 0;
  min-height: var(--wy-appbar-height, 3rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
}

.wy-toolbar {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  justify-items: center;
  min-height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  flex: 1 0 var(--wy-appbar-height, 3rem);
  column-gap: 0.25rem;
  line-height: var(--wy-line-height-base, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}

.wy-toolbar-center {
  margin: 0 auto;
  border-radius: var(--wy-border-radius, 0.5rem);
}
.wy-toolbar-center .wy-input {
  text-align: center;
}

.wy-toolbar-text {
  margin-left: 0.25rem;
}

.wy-footerbars {
  padding-bottom: var(--wy-footerbar-height, 4rem);
}
.wy-footerbars > .wy-toolbar {
  box-shadow: none;
}

.wy-footerbar {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1020;
}
.wy-footerbar::after {
  content: "";
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px 1px 0px 0px inset;
  position: absolute;
  width: 100vw;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: -1;
  backface-visibility: hidden;
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-footerbar::after {
    backdrop-filter: blur(0.5rem);
  }
}
.wy-footerbar .wy-buttons {
  flex-direction: row-reverse;
}
.wy-footerbar .wy-buttons > :not(:last-child) {
  margin: 0 0 0 0.5rem;
}

.wy-footerbar-sticky {
  position: sticky;
}

.wy-footerbars-fixed .wy-footerbar {
  position: fixed;
}
.wy-footerbars-fixed .wy-footerbar::after {
  position: fixed;
  height: var(--wy-footerbar-height, 4rem);
}

.wy-avatar {
  border-radius: 50%;
}

.wy-avatar-initials {
  background-color: var(--wy-component-avatar-background-color, var(--wy-primary, var(--wy-primary-40, #006399)));
  color: var(--wy-component-avatar-color, var(--wy-on-primary, var(--wy-white, #ffffff)));
  width: var(--wy-component-avatar-size, 2rem);
  height: var(--wy-component-avatar-size, 2rem);
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  font-size: calc(var(--wy-component-avatar-size, 2rem));
}
.wy-avatar-initials > span {
  font-size: max(8px, var(--wy-avatar-font-size, 0.382em));
  font-weight: var(--wy-avatar-font-weight, 600);
  line-height: 1;
}

.wy-avatar-header {
  padding: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wy-avatar-presence {
  position: relative;
  display: flex;
}

.wy-avatar-group {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: var(--wy-component-avatar-size, 2rem);
  height: var(--wy-component-avatar-size, 2rem);
}

.wy-avatar-group wy-avatar:first-child {
  position: absolute;
  top: 0;
  left: 0;
  display: unset;
  -webkit-mask-image: radial-gradient(at bottom right, rgba(0, 0, 0, 0) calc(35% + 0.125rem), rgb(0, 0, 0) calc(35% + 0.1875rem));
  mask-image: radial-gradient(at bottom right, rgba(0, 0, 0, 0) calc(35% + 0.125rem), rgb(0, 0, 0) calc(35% + 0.1875rem));
}

.wy-avatar-group wy-avatar:last-child {
  position: absolute;
  bottom: 0;
  right: 0;
  display: unset;
}

.wy-presence {
  background-color: var(--wy-component-background-color, transparent);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: -5%;
  box-sizing: border-box;
}
.wy-presence:not(.wy-presence-active) {
  display: none;
}
.wy-presence::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: inherit;
  background-color: var(--wy-presence-active, var(--wy-green-light, #00a38b));
  background-clip: content-box;
  padding: 0.125rem;
  box-sizing: border-box;
}

.wy-presence-away::after {
  background-color: var(--wy-presence-away, var(, ));
}

.wy-presence-in-text {
  position: absolute;
  top: 0.375rem;
  left: 0.25rem;
  bottom: auto;
  right: auto;
}

.wy-button {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
  color: var(--wy-component-color);
  background: var(--wy-component-background-color, transparent);
  padding: var(--wy-btn-padding-y, 0.5rem) var(--wy-btn-padding-x, 1.5rem);
  font-family: var(--wy-btn-font-family, var(--wy-font-family, unset)), inherit;
  font-size: var(--wy-btn-font-size, var(--wy-font-size-base, 1rem));
  font-weight: var(--wy-btn-font-weight, 400);
  line-height: var(--wy-btn-line-height, var(--wy-line-height, 1.5));
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--wy-btn-border-width, 0) solid var(--wy-btn-border-color, transparent);
  border-radius: var(--wy-btn-border-radius, 1.25rem);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  position: relative;
}
.wy-button:not(.wy-button-link, :disabled) > * {
  z-index: 3;
}
.wy-button:not(.wy-button-link, :disabled)::before {
  content: "";
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: var(--wy-component-color);
  opacity: 0%;
}
.wy-button:not(.wy-button-link, :disabled):hover::before {
  opacity: 8%;
}
.wy-button:not(.wy-button-link, :disabled):focus::before, .wy-button:not(.wy-button-link, :disabled):active::before, .wy-button:not(.wy-button-link, :disabled).wy-active::before {
  opacity: 12%;
}
.wy-button:disabled {
  opacity: var(--wy-opacity-disabled, 38%);
  cursor: unset;
  pointer-events: none;
}

.wy-button-icon {
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  width: 2.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  line-height: 1;
  border-radius: var(--wy-border-radius-pill, 50rem);
  border-width: 0;
  align-items: center;
  justify-content: center;
}
.wy-button-icon.wy-active {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-button-icon-inline {
  background: var(--wy-component-background-color);
  color: currentColor;
  border-radius: var(--wy-border-radius-pill, 50rem);
  display: flex;
  width: auto;
  background-clip: content-box;
}

.wy-button-inline {
  border-radius: var(--wy-border-radius-pill, 50rem);
  padding: 0.5rem 0.75rem;
}

.wy-button-primary {
  --wy-component-background-color: var(--wy-primary, var(--wy-primary-40, #006399));
  --wy-component-color: var(--wy-on-primary, var(--wy-white, #ffffff));
}

.wy-button-variant {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
}

.wy-button-primary-text {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-button-link {
  padding: 0;
  color: var(--wy-link-color, var(--wy-primary, var(--wy-primary-40, #006399)));
  text-decoration: var(--wy-link-decoration, none);
}
.wy-button-link:hover, .wy-button-link:focus {
  text-decoration: var(--wy-link-hover-decoration, unset);
}

.wy-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.wy-code, .wy-content {
  /*pre[class*="language-"]::-moz-selection,
  pre[class*="language-"] ::-moz-selection,
  code[class*="language-"]::-moz-selection,
  code[class*="language-"] ::-moz-selection {
    text-shadow: none;
    background: #ffffff;
  }

  pre[class*="language-"]::selection,
  pre[class*="language-"] ::selection,
  code[class*="language-"]::selection,
  code[class*="language-"] ::selection {
    text-shadow: none;
    background: #ffffff;
  }*/
  /* Code blocks */
}
.wy-code pre, .wy-content pre {
  text-wrap: pretty;
}
.wy-code code[class*=language-],
.wy-code pre[class*=language-], .wy-content code[class*=language-],
.wy-content pre[class*=language-] {
  color: var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  text-align: left;
  white-space: pre-wrap;
  word-spacing: normal;
  word-break: normal;
  word-wrap: break-word;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}
@media print {
  .wy-code code[class*=language-],
  .wy-code pre[class*=language-], .wy-content code[class*=language-],
  .wy-content pre[class*=language-] {
    text-shadow: none;
  }
}
.wy-code pre[class*=language-], .wy-content pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}
.wy-code :not(pre) > code[class*=language-],
.wy-code pre[class*=language-], .wy-content :not(pre) > code[class*=language-],
.wy-content pre[class*=language-] {
  color: var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));
  background: var(--wy-background, var(--wy-neutral-99, #fcfcff));
}
.wy-code :not(pre) > code[class*=language-], .wy-content :not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}
.wy-code .token.variable, .wy-content .token.variable {
  color: var(--wy-code-variable, var(--wy-code-variable-light, #001080));
}
.wy-code .token.operator, .wy-content .token.operator {
  color: var(--wy-code-operator, var(--wy-code-operator-light, #000000));
}
.wy-code .token.prolog, .wy-content .token.prolog {
  color: var(--wy-code-prolog, var(--wy-code-prolog-light, #000080));
}
.wy-code .token.comment, .wy-content .token.comment {
  color: var(--wy-code-comment, var(--wy-code-comment-light, #008000));
}
.wy-code .token.builtin, .wy-content .token.builtin {
  color: var(--wy-code-builtin, var(--wy-code-builtin-light, #0070C1));
}
.wy-code .token.number, .wy-content .token.number {
  color: var(--wy-code-number, var(--wy-code-number-light, #098658));
}
.wy-code .token.inserted, .wy-content .token.inserted {
  color: var(--wy-code-inserted, var(--wy-code-inserted-light, #098658));
}
.wy-code .token.constant, .wy-content .token.constant {
  color: var(--wy-code-constant, var(--wy-code-constant-light, #811F3F));
}
.wy-code .token.hexcode, .wy-content .token.hexcode {
  color: var(--wy-code-hexcode, var(--wy-code-hexcode-light, #811F3F));
}
.wy-code .token.regex, .wy-content .token.regex {
  color: var(--wy-code-regex, var(--wy-code-regex-light, #811F3F));
}
.wy-code .token.char, .wy-content .token.char {
  color: var(--wy-code-char, var(--wy-code-char-light, #811F3F));
}
.wy-code .token.tag, .wy-content .token.tag {
  color: var(--wy-code-tag, var(--wy-code-tag-light, #800000));
}
.wy-code .token.attr-name, .wy-content .token.attr-name {
  color: var(--wy-code-attr-name, var(--wy-code-attr-name-light, #E50000));
}
.wy-code .token.selector, .wy-content .token.selector {
  color: var(--wy-code-selector, var(--wy-code-selector-light, #E50000));
}
.wy-code .token.property, .wy-content .token.property {
  color: var(--wy-code-property, var(--wy-code-property-light, #E50000));
}
.wy-code .token.deleted, .wy-content .token.deleted {
  color: var(--wy-code-deleted, var(--wy-code-deleted-light, #A31515));
}
.wy-code .token.string, .wy-content .token.string {
  color: var(--wy-code-string, var(--wy-code-string-light, #A31515));
}
.wy-code .token.changed, .wy-content .token.changed {
  color: var(--wy-code-changed, var(--wy-code-changed-light, #0451A5));
}
.wy-code .token.punctuation, .wy-content .token.punctuation {
  color: var(--wy-code-punctuation, var(--wy-code-punctuation-light, #000000));
}
.wy-code .token.function, .wy-content .token.function {
  color: var(--wy-code-function, var(--wy-code-function-light, #0000FF));
}
.wy-code .token.keyword, .wy-content .token.keyword {
  color: var(--wy-code-keyword, var(--wy-code-keyword-light, #AF00DB));
}
.wy-code .token.class-name, .wy-content .token.class-name {
  color: var(--wy-code-class-name, var(--wy-code-class-name-light, #267F99));
}
.wy-code .token.important,
.wy-code .token.bold, .wy-content .token.important,
.wy-content .token.bold {
  font-weight: bold;
}
.wy-code .token.italic, .wy-content .token.italic {
  font-style: italic;
}

.wy-content {
  overflow-wrap: break-word;
  min-width: 0;
}
.wy-content :not(pre) > code {
  overflow-wrap: inherit;
}
.wy-content pre, .wy-content pre > code[class*=language-] {
  white-space: pre-wrap;
}
.wy-content :last-child {
  margin-bottom: 0;
}
.wy-content:empty {
  display: none;
}

.wy-hashtag {
  color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-mention {
  font-weight: 500;
}

.wy-dropdown,
.wy-dropup {
  position: relative;
}

.wy-dropup .wy-dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.wy-dropdown-toggle {
  white-space: nowrap;
}

.wy-dropdown-menu {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  position: absolute;
  z-index: 1000;
  min-width: 10rem;
  padding: 0 0;
  margin: 0;
  font-size: var(--wy-font-size-base, 1rem);
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  display: block;
}
.wy-dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.25rem;
}
.wy-dropup .wy-dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
[data-bs-toggle=dropdown] ~ .wy-dropdown-menu:not(.show) {
  display: none;
}
[data-bs-toggle=dropdown] ~ .wy-dropdown-menu[hidden].show {
  display: block !important;
}

.wy-dropdown-menu-end {
  right: 0;
}

.wy-dropdown-item {
  background-color: transparent;
  color: var(--wy-component-color, var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e)));
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  clear: both;
  font-family: var(--wy-font-family, unset), inherit;
  font-size: inherit;
  font-weight: 400;
  line-height: 1;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  border: 0;
  gap: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.wy-dropdown-item:hover, .wy-dropdown-item:focus {
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  text-decoration: none;
}
.wy-dropdown-item.wy-active, .wy-dropdown-item:active {
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  text-decoration: none;
}
.wy-dropdown-item.wy-disabled, .wy-dropdown-item:disabled {
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  pointer-events: none;
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-dropdown-item > img, .wy-dropdown-item > wy-icon {
  margin-right: 0.5rem;
}
.wy-dropdown-item > img, .wy-dropdown-item > img .wy-icon, .wy-dropdown-item > wy-icon, .wy-dropdown-item > wy-icon .wy-icon {
  color: inherit;
}
.wy-dropdown-item:active > wy-icon, .wy-dropdown-item:active > wy-icon .wy-icon {
  color: inherit;
}
.wy-dropdown-item.wy-option wy-icon {
  visibility: hidden;
}
.wy-dropdown-item.wy-option.wy-selected wy-icon {
  visibility: visible;
}

.wy-dropdown-divider {
  height: 0;
  margin: 0;
  overflow: hidden;
  border: none;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-emoji {
  font-size: 1.25em;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  line-height: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

img.wy-emoji, svg.wy-emoji {
  vertical-align: -0.25em;
}

.wy-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  position: relative;
}

.wy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  position: relative;
  width: var(--wy-component-icon-width);
  height: var(--wy-component-icon-height);
}
.wy-icon:not([width]) {
  width: var(--wy-component-icon-width, 1.5rem);
}
.wy-icon:not([height]) {
  height: var(--wy-component-icon-height, 1.5rem);
}

.wy-icon-first {
  margin-left: -0.5rem;
}

.wy-icon-last {
  margin-right: -0.5rem;
}

.wy-icon-padded {
  margin: 16.66666667%;
}

.wy-icon-inline {
  vertical-align: -0.25em;
}

.wy-icon-overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  background: var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
  border-radius: 50%;
  border: 1px solid var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
}

.wy-icon-stack {
  display: inline-flex;
  position: relative;
  line-height: 1;
}
.wy-icon-stack .wy-icon:last-child, .wy-icon-stack > svg:last-child {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
  border-radius: 50%;
  width: calc(var(--wy-component-icon-width) / 2);
  height: calc(var(--wy-component-icon-height) / 2);
}

.wy-icon-active-stack {
  display: inline-flex;
  position: relative;
  line-height: 1;
}
.wy-icon-active-stack .wy-icon-stack-item {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  align-self: center;
  justify-self: center;
  margin: auto;
}
.wy-icon-active-stack .wy-icon-stack-item:last-child {
  position: absolute;
  opacity: 0;
}
.wy-icon-active-stack.wy-active .wy-icon-stack-item:first-child, .wy-active .wy-icon-active-stack .wy-icon-stack-item:first-child {
  opacity: 0;
}
.wy-icon-active-stack.wy-active .wy-icon-stack-item:last-child, .wy-active .wy-icon-active-stack .wy-icon-stack-item:last-child {
  opacity: 1;
}

.wy-icon:not([class*=wy-icon-color-]):not([class*=wy-kind-]):not([data-icon=progress]) * {
  fill: currentColor;
}

.wy-content-icon {
  color: var(--wy-component-color, var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e)));
  border-radius: var(--wy-component-border-radius, var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1rem 2rem;
  margin: auto;
}
.wy-content-icon > .wy-icon-stack, .wy-content-icon > .wy-icon, .wy-content-icon > wy-icon, .wy-content-icon ::slotted(.wy-icon-stack), .wy-content-icon ::slotted(.wy-icon), .wy-content-icon ::slotted(wy-icon) {
  --wy-component-icon-width: 4rem;
  --wy-component-icon-height: 4rem;
}

.wy-content-name, .wy-content-meta {
  padding: 1rem 2rem;
  text-align: center;
}

.wy-icon-color-theme *, .wy-icon-color-theme * * {
  fill: var(--wy-theme, var(, ));
}

.wy-icon-color-primary *, .wy-icon-color-primary * * {
  fill: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-icon-color-secondary *, .wy-icon-color-secondary * * {
  fill: var(--wy-secondary, var(--wy-secondary-40, #3b6a1c));
}

.wy-icon-color-tertiary *, .wy-icon-color-tertiary * * {
  fill: var(--wy-tertiary, var(--wy-tertiary-40, #3b6a1c));
}

.wy-icon-color-surface *, .wy-icon-color-surface * * {
  fill: var(--wy-surface, var(--wy-neutral-99, #fcfcff));
}

.wy-icon-color-surface-variant *, .wy-icon-color-surface-variant * * {
  fill: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}

.wy-icon-color-error *, .wy-icon-color-error * * {
  fill: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-icon-color-warning *, .wy-icon-color-warning * * {
  fill: var(--wy-warning, var(--wy-warning-70, #afb140));
}

.wy-icon-color-blue *, .wy-icon-color-blue * * {
  fill: var(--wy-blue, var(--wy-blue-light, #89a9fc));
}

.wy-icon-color-indigo *, .wy-icon-color-indigo * * {
  fill: var(--wy-indigo, var(--wy-indigo-light, #9185de));
}

.wy-icon-color-purple *, .wy-icon-color-purple * * {
  fill: var(--wy-purple, var(--wy-purple-light, #c675b7));
}

.wy-icon-color-pink *, .wy-icon-color-pink * * {
  fill: var(--wy-pink, var(--wy-pink-light, #d57194));
}

.wy-icon-color-red *, .wy-icon-color-red * * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-icon-color-orange *, .wy-icon-color-orange * * {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-icon-color-yellow *, .wy-icon-color-yellow * * {
  fill: var(--wy-yellow, var(--wy-yellow-light, #afb140));
}

.wy-icon-color-green *, .wy-icon-color-green * * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-icon-color-teal *, .wy-icon-color-teal * * {
  fill: var(--wy-teal, var(--wy-teal-light, #00a0a8));
}

.wy-icon-color-cyan *, .wy-icon-color-cyan * * {
  fill: var(--wy-cyan, var(--wy-cyan-light, #0082a1));
}

.wy-icon-color-gray *, .wy-icon-color-gray * * {
  fill: var(--wy-gray, var(--wy-gray-light, #76777a));
}

.wy-icon-color-black *, .wy-icon-color-black * * {
  fill: var(--wy-black, var(, ));
}

.wy-icon-color-white *, .wy-icon-color-white * * {
  fill: var(--wy-white, var(, ));
}

[class*=wy-kind-], [class*=wy-kind-] * {
  fill: var(--wy-gray, var(--wy-gray-light, #76777a));
}

.wy-kind-archive {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-kind-audio * {
  fill: var(--wy-teal, var(--wy-teal-light, #00a0a8));
}

.wy-kind-code * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-kind-document * {
  fill: var(--wy-blue, var(--wy-blue-light, #89a9fc));
}

.wy-kind-email * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-kind-presentation * {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-kind-spreadsheet * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-kind-image * {
  fill: var(--wy-pink, var(--wy-pink-light, #d57194));
}

.wy-kind-text * {
  fill: var(--wy-cyan, var(--wy-cyan-light, #0082a1));
}

.wy-kind-video * {
  fill: var(--wy-purple, var(--wy-purple-light, #c675b7));
}

.wy-ext-pdf * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-kind-text-icon {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: -0.3125rem;
}

[data-icon=progress].wy-icon-primary {
  color: var(--wy-primary, var(--wy-primary-40, #006399));
}
[data-icon=progress] :first-child {
  fill: none;
  stroke: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
[data-icon=progress] :last-child {
  fill: none;
  stroke: currentColor;
}

.wy-image-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  position: relative;
  border-radius: var(--wy-border-radius, 0.5rem);
  overflow: hidden;
  column-gap: 1px;
  row-gap: 1px;
}
.wy-image-grid .wy-image {
  padding: 0;
  width: 50%;
  position: relative;
  flex: auto;
  background-color: inherit;
  background-clip: content-box;
}
.wy-image-grid .wy-image:first-of-type:not(:nth-last-of-type(2)) {
  flex-basis: 100% !important;
}
.wy-image-grid .wy-image-area {
  display: block;
  height: 100%;
  cursor: pointer;
}
.wy-image-grid .wy-image-area img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.wy-image-grid .wy-more {
  position: absolute;
  line-height: 100%;
  color: var(--wy-white, var(, ));
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, var(--wy-opacity-disabled, 38%));
}

.wy-title {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 400;
  font-size: 2.5rem;
  line-height: 3rem;
}

.wy-headline {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2rem;
}

.wy-label {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0rem;
  margin-bottom: 0rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
}

.wy-input {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  display: block;
  width: 100%;
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  font-weight: var(--wy-input-font-weight, var(--wy-font-weight, unset));
  line-height: var(--wy-input-line-height, var(--wy-line-height, 1.5rem));
  background-clip: padding-box;
  appearance: none;
  border-radius: var(--wy-input-border-radius, var(--wy-border-radius, 0.5rem));
}
.wy-input:focus {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-input::placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 1;
}
.wy-input:disabled {
  opacity: 38%;
}
.wy-input::file-selector-button, .wy-input::-webkit-file-upload-button {
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
  margin: calc(-1 * var(--wy-input-padding-y, 0.4375rem)) calc(-1 * var(--wy-input-padding-x, 0.75rem));
  margin-inline-end: var(--wy-input-padding-x, 0.75rem);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--wy-input-border-width, 1px);
  border-radius: 0;
}
.wy-input:hover:not(:disabled):not([readonly])::file-selector-button, .wy-input:hover:not(:disabled):not([readonly]) ::-webkit-file-upload-button {
  background-color: var(--wy-component-background-color);
}
.wy-input[type=file] {
  overflow: hidden;
}
.wy-input[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.wy-input::-webkit-date-and-time-value {
  height: calc(var(--wy-input-line-height, var(--wy-line-height, 1.5rem)) * 1em);
}
.wy-input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.wy-input-filled {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: 1.25rem;
  border-color: var(--wy-component-background-color);
}
.wy-input-filled:focus {
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-input-label {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0rem;
  margin-bottom: 0rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  display: block;
  margin-bottom: 0.5rem;
}

.wy-description {
  margin-top: 0.25rem;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-is-invalid, .wy-is-invalid:focus {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-invalid-feedback {
  margin-top: 0.25rem;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
  color: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-input-group {
  position: relative;
}
.wy-input-group > wy-icon {
  position: absolute;
  top: 0rem;
  left: 0rem;
  z-index: 4;
}
.wy-input-group > wy-icon + .wy-input {
  padding-left: 2.5rem;
}

.wy-input-group-button-icon {
  position: absolute;
  top: 0rem;
  right: 0rem;
  z-index: 4;
  border-radius: var(--wy-input-border-radius, var(--wy-border-radius, 0.5rem));
}

.wy-input-group-input-filled ~ .wy-button-icon {
  border-radius: 1.25rem;
}

.wy-input-group-input {
  padding-right: 2.5rem;
}
.wy-input-group-input:placeholder-shown ~ .wy-input-group-button-icon[type=reset] {
  display: none;
}
.wy-input-group-input:not(:placeholder-shown) ~ .wy-input-group-button-icon[type=reset] + .wy-input-group-button-icon {
  display: none;
}

.wy-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  text-decoration: none;
  min-height: 3rem;
}
.wy-item > .wy-avatar, .wy-item > wy-icon, .wy-item > wy-spinner, .wy-item > .wy-icon-stack {
  margin-left: -0.25rem;
}

.wy-item-body {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-item-body > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-item-body + .wy-dropdown, .wy-item-body + .wy-button-icon, .wy-item-body + .wy-item-actions {
  margin-right: -0.5rem;
}
.wy-item-body + .wy-emoji {
  margin-right: 0.125rem;
}

.wy-item-title {
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  font-weight: var(--wy-headings-font-weight, 500);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-item-text {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}
.wy-item-text .wy-icon {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: -0.3125rem;
}

.wy-item-actions {
  --wy-component-background-color: transparent;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.wy-item-actions-top {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  margin: 0 !important;
}

.wy-item-actions-bottom {
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  margin: 0 !important;
}

.wy-item-body:has(+ .wy-item-actions-bottom) .wy-item-row:last-child {
  margin-right: 4.5rem;
}

.wy-item-body:has(+ .wy-item-actions-top) .wy-item-row:first-child {
  margin-right: 2rem;
}

.wy-action-label {
  margin-right: 0.5rem;
  font-style: italic;
}

.wy-item-row {
  display: flex;
  align-items: baseline;
}
.wy-item-row:first-child {
  margin-bottom: 0.125rem;
}
.wy-item-row .wy-item-title {
  margin-right: auto;
}
.wy-item-row .wy-item-text {
  margin-right: auto;
}
.wy-item-row .wy-meta {
  margin: 0 0.25rem;
  white-space: nowrap;
}

.wy-item-hover {
  user-select: none;
  cursor: pointer;
}
.wy-item-hover:hover, .wy-item-hover:focus {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  text-decoration: none;
}
.wy-item-hover:active {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-item-hover.wy-disabled, .wy-item-hover:disabled {
  opacity: var(--wy-opacity-disabled, 38%);
  pointer-events: none;
}
.wy-item-hover.wy-active {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-color: var(--wy-component-background-color);
}

.wy-item-trashed {
  text-decoration: line-through;
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-item-trashed.wy-item-hover:hover {
  opacity: 1;
}

.wy-item-lg {
  padding: 0.75rem;
  min-height: 4.5rem;
  gap: 0.75rem;
}
.wy-item-lg > .wy-avatar, .wy-item-lg > wy-icon, .wy-item-lg > .wy-icon-stack {
  margin-left: 0;
}

.wy-list {
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.wy-list .wy-item:not(.wy-item-hover) {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-list .wy-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.wy-list .wy-item:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.wy-list-bordered {
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  gap: 0;
}
.wy-list-bordered .wy-item {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-left: none;
  border-right: none;
}
.wy-list-bordered .wy-item:first-child {
  border-top: none;
}
.wy-list-bordered .wy-item:last-child {
  border-bottom: none;
}
.wy-list-bordered .wy-item + .wy-list-bordered .wy-item {
  border-top-width: 0;
}

.wy-messages {
  padding: 1rem 1rem 1rem 0.75rem;
  flex: 1 1 100%;
}

.wy-message-placeholder {
  opacity: 0.5;
}

.wy-date-separator {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  pointer-events: none;
  margin: 0.5rem;
  text-align: center;
  position: sticky;
  top: 1.5rem;
  z-index: 10;
}
.wy-date-separator time {
  background: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  padding: 0.25rem 0.5rem;
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  display: inline-block;
}

.wy-appbars + .wy-pane-body .wy-date-separator {
  top: calc(var(--wy-appbar-height, 3rem) + 1.5rem);
}

.wy-message {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.wy-message .wy-image-grid,
.wy-message .wy-attachments {
  border-radius: var(--wy-border-radius, 0.5rem);
}

.wy-message-meta {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  margin: 0 0 0.25rem 0.25rem;
  color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
}

.wy-message-bubble {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: calc(var(--wy-border-radius, 0.5rem) + .5rem);
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.75rem;
  max-width: min(32rem, 100% - 2rem);
}
.wy-message-bubble > div {
  flex: 1 1 100%;
}
.wy-message-bubble .wy-likes, .wy-message-bubble .wy-reactions-line {
  position: relative;
  height: 0;
  min-height: 0;
  max-height: 0;
  margin: 0 -0.75rem -0.75rem;
  flex: 0 0 0;
}
.wy-message-bubble .wy-like-count {
  background: var(--wy-component-background-color);
  border-radius: var(--wy-border-radius-pill, 50rem);
  color: currentColor;
}
.wy-message-bubble .wy-reactions-line, .wy-message-bubble wy-reactions {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.wy-message-author {
  margin: 1.375rem 0.5rem 0 0;
}

.wy-message-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  min-width: 0;
  position: relative;
}

.wy-message-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
}

.wy-message-me {
  margin-right: 0;
  margin-left: 2.5rem;
  align-items: flex-end;
}
.wy-message-me .wy-message-meta {
  margin: 0 0.25rem 0.25rem 0;
}
.wy-message-me .wy-message-content {
  align-items: flex-end;
}
.wy-message-me .wy-message-content-row {
  flex-direction: row-reverse;
}
.wy-message-me .wy-message-bubble {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-message-me .wy-likes {
  flex-direction: row-reverse;
}
.wy-message-me .wy-reactions-line, .wy-message-me wy-reactions {
  display: flex;
  flex-direction: row;
}
.wy-message-me .wy-reactions-line .wy-dropdown-menu, .wy-message-me wy-reactions .wy-dropdown-menu {
  right: 0;
}

.wy-message-emoji .wy-message-bubble {
  background: none;
  padding: 0 0 0.75rem;
}
.wy-message-emoji .wy-content .wy-emoji {
  width: 3rem;
  height: 3rem;
  margin: 0;
}
.wy-message-emoji.wy-message-me .wy-content {
  text-align: end;
}

.wy-readby-status {
  display: flex;
  gap: 0.25rem;
  height: 18px;
  justify-content: flex-end;
  margin-top: -0.125rem;
}

.wy-status-pending {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-status-sent {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-status-delivered {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-message-readmore {
  justify-self: center;
  text-align: center;
}

.wy-meta {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-meta-sm {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
}

.wy-viewport {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2147483647; /* max possible z-index */
  pointer-events: none;
}

.wy-overlays {
  pointer-events: none;
  width: 100%;
  height: 100%;
  max-width: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
  overflow-y: initial;
  overflow-x: initial;
  perspective: 100rem;
  perspective-origin: center center;
}
.wy-overlays .wy-panel:not(.wy-transition) {
  transform: translateZ(-4rem) !important;
}
.wy-overlays .wy-panel .wy-controls {
  position: absolute;
  border-bottom: none;
  flex-direction: row;
  transition: opacity 0.1s 0.2s step-end;
}
.wy-overlays .wy-panel .wy-controls wy-icon {
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
}
.wy-overlays .wy-panel.wy-loaded .wy-controls {
  pointer-events: none;
  opacity: 0;
}
.wy-overlays .wy-panel .wy-panel-frame {
  background-color: transparent;
}
@media (min-width: 768px) {
  .wy-overlays .wy-panel.wy-modal {
    left: auto;
    right: auto;
    top: 2rem;
    bottom: 3.2rem;
    margin-left: 4rem;
    margin-top: auto;
    margin-right: 4rem;
    margin-bottom: auto;
    border-radius: var(--wy-border-radius, 0.5rem);
    box-shadow: var(--wy-shadow-level4, 0 1rem 2.25rem 0.125rem rgba(0, 0, 0, 0.14), 0 0.375rem 1.875rem 0.3125rem rgba(0, 0, 0, 0.12), 0 0.5rem 0.625rem -0.3125rem rgba(0, 0, 0, 0.2));
    width: 32rem;
    max-height: 32rem;
  }
  .wy-overlays .wy-panel.wy-modal:not(.wy-scroll-y) {
    overflow: hidden;
  }
}
@media (min-width: 768px) {
  .wy-overlays .wy-panel.wy-modal-full {
    left: 1rem;
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    margin: 0;
    border-radius: var(--wy-border-radius, 0.5rem);
    box-shadow: var(--wy-shadow-level4, 0 1rem 2.25rem 0.125rem rgba(0, 0, 0, 0.14), 0 0.375rem 1.875rem 0.3125rem rgba(0, 0, 0, 0.12), 0 0.5rem 0.625rem -0.3125rem rgba(0, 0, 0, 0.2));
    width: auto;
    max-height: none;
  }
  .wy-overlays .wy-panel.wy-modal-full:not(.wy-scroll-y) {
    overflow: hidden;
  }
}
.wy-overlays .wy-panel.wy-loading .wy-controls {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  opacity: 1;
}

tr.wy-pager {
  pointer-events: none;
}

:not(tr).wy-pager:not(:empty) {
  display: block;
  text-align: center;
  margin: 1rem auto;
}

tr.wy-pager td {
  text-align: center;
  border: 0;
}
tr.wy-pager td .wy-spinner {
  display: inline;
  margin: 1rem auto;
}

.wy-grid .wy-pager {
  display: flex;
}

.wy-pane {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0;
  height: 100%;
  flex: 1 1 auto;
}

.wy-pane-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.wy-pane-group {
  padding: 0.75rem;
}

.wy-pane-background {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}

.wy-panels {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overscroll-behavior: contain;
  overflow-y: auto;
  overflow-x: hidden;
}

.wy-panel {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
}
.wy-panel .wy-controls {
  top: 0.25rem;
  left: 0.25rem;
  min-width: 2.5rem;
  width: auto;
  display: flex;
  z-index: 10000;
  order: -1;
  flex-direction: row-reverse;
  border-bottom: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}
.wy-panel .wy-controls:empty {
  display: none;
}
.wy-panel .wy-controls wy-icon {
  color: var(--wy-component-color);
}
.wy-panel .wy-panel-frame {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-delay: 0.2s;
  opacity: 1;
}
.wy-panel .wy-panel-frame:not([src]) {
  display: none;
}
.wy-panel:not(.wy-loaded) .wy-panel-frame {
  opacity: 0;
  transition: opacity 0.2s step-start;
  transition-delay: 0.1s;
}
.wy-panel.wy-open {
  pointer-events: all;
  z-index: 5;
}
.wy-panel.wy-open[data-title]::before {
  content: attr(data-title);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  opacity: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.1s step-end;
  transition-delay: 0.2s;
  font-family: var(--wy-font-family, unset), inherit;
  line-height: var(--wy-line-height, 1.5);
  font-weight: var(--wy-font-weight, unset);
  background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
  backface-visibility: hidden;
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-panel.wy-open[data-title]::before {
    backdrop-filter: blur(0.5rem);
  }
}
.wy-panel.wy-open::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: 0s;
}
.wy-panel.wy-open.wy-loading[data-title]::before {
  opacity: 1;
}
.wy-panel.wy-open.wy-loading::after {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: 0.5s;
  opacity: 1;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' width='24' height='24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cstyle type='text/css'%3Eg%7Banimation:rotate 2s linear infinite;transform-origin:center center%7Dcircle%7Bstroke-dasharray:1,100;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,color 6s ease-in-out infinite%7D@keyframes rotate%7B100%25%7Btransform:rotate(360deg)%7D%7D@keyframes dash%7B0%25%7Bstroke-dasharray:1,100;stroke-dashoffset:0%7D50%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-17.5px%7D100%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-62px%7D%7D@keyframes color%7B0%25,100%25%7Bstroke:%23216eb4%7D40%25%7Bstroke:%2328b7cf%7D66%25%7Bstroke:%23216eb4%7D80%25,90%25%7Bstroke:%2328b7cf%7D%7D%3C/style%3E%3Cg%3E%3Ccircle fill='none' cx='12' cy='12' r='11' stroke-linecap='butt' stroke-width='2' /%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 2rem;
  background-color: transparent;
}

.wy-panel {
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) 0.01s, transform var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) 0.01s, visibility 0.01s step-end var(--wy-transition-duration-fast, 0.1s);
}
.wy-panel.wy-open {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), visibility var(--wy-transition-duration, 0.2s) step-start;
  visibility: visible;
}
.wy-panel.wy-open.wy-transition {
  opacity: 1;
  transform: none;
}

.wy-panel-frame {
  flex: 1 1 100%;
  border: 0;
}

.wy-picker-list {
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border: none;
}
.wy-picker-list > .wy-picker-list-item:first-child, .wy-picker-list > :first-child .wy-picker-list-item {
  border-top: none;
}
.wy-picker-list > .wy-picker-list-item:last-child, .wy-picker-list > :last-child .wy-picker-list-item {
  border-bottom: none;
}

.wy-picker-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
}
.wy-picker-list-item > wy-icon {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  flex: 0 0 auto;
}
.wy-picker-list-item > button {
  margin-block-start: auto;
  flex: 0 0 auto;
}

.wy-picker-list-item-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-main {
  display: flex;
  height: calc(100% - var(--wy-appbar-height, 3rem));
  min-height: 0;
}
@media (max-width: 767.98px) {
  .wy-main {
    flex-direction: column;
  }
}

.wy-preview {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  position: relative;
  flex: 1 1 100%;
  min-width: 16rem;
  min-height: 16rem;
  max-height: 100%;
  max-width: 100%;
}

.wy-preview-swiper {
  display: flex;
  flex-direction: row;
  flex: 1 1 100%;
  align-items: center;
  justify-content: start;
  min-width: 16rem;
  min-height: 16rem;
  max-height: 100%;
  max-width: 100%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: auto;
  overscroll-behavior-x: none;
  scrollbar-width: none;
}
.wy-preview-swiper::-webkit-scrollbar {
  display: none;
}

.wy-preview-swiper-disabled {
  overflow-x: hidden;
}

.wy-preview-area {
  position: relative;
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  scroll-snap-stop: always;
  scroll-snap-align: center;
}

.wy-nav-prev, .wy-nav-next {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  position: absolute;
  top: 50%;
  z-index: 1000;
  border-radius: 50%;
}

.wy-nav-prev {
  left: 0.5rem;
}

.wy-nav-next {
  right: 0.5rem;
}

.wy-document {
  --wy-component-background-color: var(--wy-background, );
  --wy-component-color: var(--wy-on-background, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  align-self: flex-start;
  padding: 2rem 3.5rem;
  width: 100%;
  min-height: 100%;
  flex: 1 0 auto;
}
@media (min-width: 768px) {
  .wy-document {
    padding: 3rem 4rem;
    margin: 2rem auto;
    border-radius: 0.125rem;
    box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
    width: 120ch;
    min-height: 170ch;
    max-width: calc(100% - 3.5rem);
  }
}

.wy-content-code {
  /*--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));

  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  */
  align-self: flex-start;
  width: 100%;
  padding: 2rem 3.5rem;
}

.wy-content-iframe {
  border: 0;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  flex: 1 1 100%;
}
.wy-content-iframe.wy-loaded {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-content-iframe.wy-loaded ~ .wy-content-iframe-fallback, .wy-content-iframe.wy-loaded ~ .wy-spinner, .wy-content-iframe.wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded) {
  position: absolute;
  visibility: hidden;
  z-index: -1;
  pointer-events: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded):not(.wy-fallback) ~ .wy-content-iframe-fallback {
  display: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback ~ .wy-spinner, .wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback ~ wy-spinner {
  display: none;
}
.wy-content-iframe ~ .wy-spinner, .wy-content-iframe ~ wy-spinner {
  margin: auto;
}

.wy-content-html pre, .wy-content-html code {
  word-break: break-word;
  white-space: pre-wrap;
}

.wy-content-image {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  /*&.wy-intrinsic-image {
    object-fit: scale-down;
  }*/
  /*&:not(.wy-intrinsic-image) {
    transition: transform var.default(--wy-transition), transform-origin var.default(--wy-transition-duration) step-end;
    //cursor: zoom-in;
  }*/
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform-origin var(--wy-transition-duration, 0.2s) step-end;
}
.wy-content-image.wy-zoom {
  cursor: zoom-out;
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform-origin var(--wy-transition-duration, 0.2s) step-start;
}
.wy-content-image img {
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
}
.wy-content-image img:not(.wy-loading-transition):not([data-controller~=image]) ~ .wy-spinner, .wy-content-image img:not(.wy-loading-transition):not([data-controller~=image]) ~ wy-spinner {
  display: none;
}
.wy-content-image img.wy-loading, .wy-content-image img[data-controller~=image] {
  transition: opacity 0.15s ease-out;
  opacity: 0;
}
.wy-content-image img.wy-loading.wy-loaded, .wy-content-image img[data-controller~=image].wy-loaded {
  opacity: 1;
  transition: opacity 0.15s ease-out;
}
.wy-content-image img.wy-loading.wy-loaded ~ img, .wy-content-image img[data-controller~=image].wy-loaded ~ img {
  transition-delay: 0.15s;
  opacity: 0;
}
.wy-content-image img.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-image img.wy-loading.wy-loaded ~ wy-spinner, .wy-content-image img[data-controller~=image].wy-loaded ~ .wy-spinner, .wy-content-image img[data-controller~=image].wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-image img.wy-responsive-image-thumb {
  position: absolute;
  z-index: -1;
}
.wy-content-image img ~ .wy-spinner, .wy-content-image img ~ wy-spinner {
  position: absolute;
}

.wy-content-video:not(.wy-error) {
  min-height: 0;
  max-width: 100%;
  max-height: 100%;
  flex: 1 1 auto;
}

.wy-content-video, .wy-content-audio {
  margin: auto;
}
.wy-content-video.wy-loading:not(.wy-loaded), .wy-content-video[data-controller~=media]:not(.wy-loaded), .wy-content-audio.wy-loading:not(.wy-loaded), .wy-content-audio[data-controller~=media]:not(.wy-loaded) {
  visibility: hidden;
}
.wy-content-video.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-video.wy-loading.wy-loaded ~ wy-spinner, .wy-content-video[data-controller~=media].wy-loaded ~ .wy-spinner, .wy-content-video[data-controller~=media].wy-loaded ~ wy-spinner, .wy-content-audio.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-audio.wy-loading.wy-loaded ~ wy-spinner, .wy-content-audio[data-controller~=media].wy-loaded ~ .wy-spinner, .wy-content-audio[data-controller~=media].wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-video:focus, .wy-content-audio:focus {
  outline: none;
}

:host(wy-pdf-viewer) {
  --annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --input-focus-border-color: Highlight;
  --input-focus-outline: 1px solid Canvas;
  --input-unfocused-border-color: transparent;
  --input-disabled-border-color: transparent;
  --input-hover-border-color: black;
  --xfa-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --xfa-focus-outline: auto;
  --focus-outline: solid 2px blue;
  --hover-outline: dashed 2px blue;
  --freetext-line-height: 1.35;
  --freetext-padding: 2px;
  --editorFreeText-editing-cursor: text;
  --editorInk-editing-cursor: pointer;
  --viewer-container-height: 0;
  --pdfViewer-padding-bottom: 0;
  --page-margin: 2rem auto;
  --page-border: none;
  --page-border-image: none;
  --spreadHorizontalWrapped-margin-LR: -3.5px;
  --scale-factor: 1;
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --input-focus-border-color: CanvasText;
    --input-unfocused-border-color: ActiveText;
    --input-disabled-border-color: GrayText;
    --input-hover-border-color: Highlight;
  }
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --xfa-focus-outline: 2px solid CanvasText;
  }
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --focus-outline: solid 3px ButtonText;
    --hover-outline: dashed 3px ButtonText;
  }
}
@media screen and (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --page-border: 1px solid CanvasText;
    --page-border-image: none;
    --spreadHorizontalWrapped-margin-LR: 3.5px;
  }
}

.wy-content-pdf {
  /* Copyright 2014 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
}
.wy-content-pdf .wy-input[data-pdf-target=pageNumber] {
  width: 3rem;
}
.wy-content-pdf .wy-input[data-pdf-target=zoomLevel] {
  width: 5rem;
}
.wy-content-pdf .wy-pdf-container {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-height: 100%;
  overflow-x: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-width: 100%;
}
.wy-content-pdf .wy-pdf-container:not(body) {
  -webkit-overflow-scrolling: touch;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
@supports (overflow-y: overlay) {
  .wy-scrollbars .wy-content-pdf .wy-pdf-container {
    overflow-y: overlay;
  }
}
.wy-content-pdf .textLayer {
  position: absolute;
  text-align: initial;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.25;
  line-height: 1;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  text-size-adjust: none;
  forced-color-adjust: none;
}
.wy-content-pdf .textLayer span,
.wy-content-pdf .textLayer br {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
.wy-content-pdf .textLayer span.markedContent {
  top: 0;
  height: 0;
}
.wy-content-pdf .textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(180, 0, 170);
  border-radius: 4px;
}
.wy-content-pdf .textLayer .highlight.appended {
  position: initial;
}
.wy-content-pdf .textLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
.wy-content-pdf .textLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
.wy-content-pdf .textLayer .highlight.middle {
  border-radius: 0;
}
.wy-content-pdf .textLayer .highlight.selected {
  background-color: rgb(0, 100, 0);
}
.wy-content-pdf .textLayer ::-moz-selection {
  background: blue;
  background: AccentColor;
}
.wy-content-pdf .textLayer ::selection {
  background: blue;
  background: AccentColor;
}
.wy-content-pdf .textLayer br::-moz-selection {
  background: transparent;
}
.wy-content-pdf .textLayer br::selection {
  background: transparent;
}
.wy-content-pdf .textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  z-index: -1;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.wy-content-pdf .textLayer .endOfContent.active {
  top: 0;
}
@media (forced-colors: active) {
  .wy-content-pdf .annotationLayer .textWidgetAnnotation input:required,
  .wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:required,
  .wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,
  .wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
  .wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
    outline: 1.5px solid selectedItem;
  }
}
.wy-content-pdf .annotationLayer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  transform-origin: 0 0;
}
.wy-content-pdf .annotationLayer section {
  position: absolute;
  text-align: initial;
  pointer-events: auto;
  box-sizing: border-box;
  transform-origin: 0 0;
}
.wy-content-pdf .annotationLayer .linkAnnotation > a,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > canvas {
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .linkAnnotation > a:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > a:hover {
  opacity: 0.2;
  background: rgb(255, 255, 0);
  box-shadow: 0 2px 10px rgb(255, 255, 0);
}
.wy-content-pdf .annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  background-image: var(--annotation-unfocused-field-background);
  border: 2px solid var(--input-unfocused-border-color);
  box-sizing: border-box;
  font: calc(9px * var(--scale-factor)) sans-serif;
  height: 100%;
  margin: 0;
  vertical-align: top;
  width: 100%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:required,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:required,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
  outline: 1.5px solid red;
}
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select option {
  padding: 0;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  border-radius: 50%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea {
  resize: none;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input[disabled],
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea[disabled],
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select[disabled],
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
  background: none;
  border: 2px solid var(--input-disabled-border-color);
  cursor: not-allowed;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:hover,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:hover,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
  border: 2px solid var(--input-hover-border-color);
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:hover,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:hover,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:hover {
  border-radius: 2px;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:focus,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:focus,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:focus {
  background: none;
  border: 2px solid var(--input-focus-border-color);
  border-radius: 2px;
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox :focus,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton :focus {
  background-image: none;
  background-color: transparent;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox :focus {
  border: 2px solid var(--input-focus-border-color);
  border-radius: 2px;
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton :focus {
  border: 2px solid var(--input-focus-border-color);
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  background-color: CanvasText;
  content: "";
  display: block;
  position: absolute;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  height: 80%;
  left: 45%;
  width: 1px;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
  transform: rotate(45deg);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  transform: rotate(-45deg);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  border-radius: 50%;
  height: 50%;
  left: 30%;
  top: 20%;
  width: 50%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb {
  font-family: monospace;
  padding-left: 2px;
  padding-right: 0;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb:focus {
  /*
   * Letter spacing is placed on the right side of each character. Hence, the
   * letter spacing of the last character may be placed outside the visible
   * area, causing horizontal scrolling. We avoid this by extending the width
   * when the element has focus and revert this when it loses focus.
   */
  width: 103%;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.wy-content-pdf .annotationLayer .popupTriggerArea {
  height: 100%;
  width: 100%;
}
.wy-content-pdf .annotationLayer .popupWrapper {
  position: absolute;
  font-size: calc(9px * var(--scale-factor));
  width: 100%;
  min-width: calc(180px * var(--scale-factor));
  pointer-events: none;
}
.wy-content-pdf .annotationLayer .popup {
  position: absolute;
  max-width: calc(180px * var(--scale-factor));
  background-color: rgb(255, 255, 153);
  box-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) rgb(136, 136, 136);
  border-radius: calc(2px * var(--scale-factor));
  padding: calc(6px * var(--scale-factor));
  margin-left: calc(5px * var(--scale-factor));
  cursor: pointer;
  font: message-box;
  white-space: normal;
  word-wrap: break-word;
  pointer-events: auto;
}
.wy-content-pdf .annotationLayer .popup > * {
  font-size: calc(9px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .popup h1 {
  display: inline-block;
}
.wy-content-pdf .annotationLayer .popupDate {
  display: inline-block;
  margin-left: calc(5px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .popupContent {
  border-top: 1px solid rgb(51, 51, 51);
  margin-top: calc(2px * var(--scale-factor));
  padding-top: calc(2px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .richText > * {
  white-space: pre-wrap;
  font-size: calc(9px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .highlightAnnotation,
.wy-content-pdf .annotationLayer .underlineAnnotation,
.wy-content-pdf .annotationLayer .squigglyAnnotation,
.wy-content-pdf .annotationLayer .strikeoutAnnotation,
.wy-content-pdf .annotationLayer .freeTextAnnotation,
.wy-content-pdf .annotationLayer .lineAnnotation svg line,
.wy-content-pdf .annotationLayer .squareAnnotation svg rect,
.wy-content-pdf .annotationLayer .circleAnnotation svg ellipse,
.wy-content-pdf .annotationLayer .polylineAnnotation svg polyline,
.wy-content-pdf .annotationLayer .polygonAnnotation svg polygon,
.wy-content-pdf .annotationLayer .caretAnnotation,
.wy-content-pdf .annotationLayer .inkAnnotation svg polyline,
.wy-content-pdf .annotationLayer .stampAnnotation,
.wy-content-pdf .annotationLayer .fileAttachmentAnnotation {
  cursor: pointer;
}
.wy-content-pdf .annotationLayer section svg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .annotationTextContent {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  pointer-events: none;
}
.wy-content-pdf .annotationLayer .annotationTextContent span {
  width: 100%;
  display: inline-block;
}
@media (forced-colors: active) {
  .wy-content-pdf .xfaLayer *:required {
    outline: 1.5px solid selectedItem;
  }
}
.wy-content-pdf .xfaLayer {
  background-color: transparent;
}
.wy-content-pdf .xfaLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(239, 203, 237);
  border-radius: 4px;
}
.wy-content-pdf .xfaLayer .highlight.appended {
  position: initial;
}
.wy-content-pdf .xfaLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
.wy-content-pdf .xfaLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
.wy-content-pdf .xfaLayer .highlight.middle {
  border-radius: 0;
}
.wy-content-pdf .xfaLayer .highlight.selected {
  background-color: rgb(203, 223, 203);
}
.wy-content-pdf .xfaPage {
  overflow: hidden;
  position: relative;
}
.wy-content-pdf .xfaContentarea {
  position: absolute;
}
.wy-content-pdf .xfaPrintOnly {
  display: none;
}
.wy-content-pdf .xfaLayer {
  position: absolute;
  text-align: initial;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  line-height: 1.2;
}
.wy-content-pdf .xfaLayer * {
  color: inherit;
  font: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-kerning: inherit;
  letter-spacing: -0.01px;
  text-align: inherit;
  text-decoration: inherit;
  box-sizing: border-box;
  background-color: transparent;
  padding: 0;
  margin: 0;
  pointer-events: auto;
  line-height: inherit;
}
.wy-content-pdf .xfaLayer *:required {
  outline: 1.5px solid red;
}
.wy-content-pdf .xfaLayer div {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer svg {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer svg * {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer a {
  color: blue;
}
.wy-content-pdf .xfaRich li {
  margin-left: 3em;
}
.wy-content-pdf .xfaFont {
  color: black;
  font-weight: normal;
  font-kerning: none;
  font-size: 10px;
  font-style: normal;
  letter-spacing: 0;
  text-decoration: none;
  vertical-align: 0;
}
.wy-content-pdf .xfaCaption {
  overflow: hidden;
  flex: 0 0 auto;
}
.wy-content-pdf .xfaCaptionForCheckButton {
  overflow: hidden;
  flex: 1 1 auto;
}
.wy-content-pdf .xfaLabel {
  height: 100%;
  width: 100%;
}
.wy-content-pdf .xfaLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.wy-content-pdf .xfaRight {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.wy-content-pdf .xfaLeft > .xfaCaption,
.wy-content-pdf .xfaLeft > .xfaCaptionForCheckButton,
.wy-content-pdf .xfaRight > .xfaCaption,
.wy-content-pdf .xfaRight > .xfaCaptionForCheckButton {
  max-height: 100%;
}
.wy-content-pdf .xfaTop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.wy-content-pdf .xfaBottom {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
}
.wy-content-pdf .xfaTop > .xfaCaption,
.wy-content-pdf .xfaTop > .xfaCaptionForCheckButton,
.wy-content-pdf .xfaBottom > .xfaCaption,
.wy-content-pdf .xfaBottom > .xfaCaptionForCheckButton {
  width: 100%;
}
.wy-content-pdf .xfaBorder {
  background-color: transparent;
  position: absolute;
  pointer-events: none;
}
.wy-content-pdf .xfaWrapped {
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaTextfield:focus,
.wy-content-pdf .xfaSelect:focus {
  background-image: none;
  background-color: transparent;
  outline: var(--xfa-focus-outline);
  outline-offset: -1px;
}
.wy-content-pdf .xfaCheckbox:focus,
.wy-content-pdf .xfaRadio:focus {
  outline: var(--xfa-focus-outline);
}
.wy-content-pdf .xfaTextfield,
.wy-content-pdf .xfaSelect {
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  border: none;
  resize: none;
  background-image: var(--xfa-unfocused-field-background);
}
.wy-content-pdf .xfaSelect {
  padding-left: 2px;
  padding-right: 2px;
  padding-inline: 2px;
}
.wy-content-pdf .xfaTop > .xfaTextfield,
.wy-content-pdf .xfaTop > .xfaSelect,
.wy-content-pdf .xfaBottom > .xfaTextfield,
.wy-content-pdf .xfaBottom > .xfaSelect {
  flex: 0 1 auto;
}
.wy-content-pdf .xfaButton {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}
.wy-content-pdf .xfaLink {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.wy-content-pdf .xfaCheckbox,
.wy-content-pdf .xfaRadio {
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  border: none;
}
.wy-content-pdf .xfaRich {
  white-space: pre-wrap;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaImage {
  -o-object-position: left top;
  object-position: left top;
  -o-object-fit: contain;
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaLrTb,
.wy-content-pdf .xfaRlTb,
.wy-content-pdf .xfaTb {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.wy-content-pdf .xfaLr {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.wy-content-pdf .xfaRl {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
}
.wy-content-pdf .xfaTb > div {
  justify-content: left;
}
.wy-content-pdf .xfaPosition {
  position: relative;
}
.wy-content-pdf .xfaArea {
  position: relative;
}
.wy-content-pdf .xfaValignMiddle {
  display: flex;
  align-items: center;
}
.wy-content-pdf .xfaTable {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.wy-content-pdf .xfaTable .xfaRow {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.wy-content-pdf .xfaTable .xfaRlRow {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  flex: 1;
}
.wy-content-pdf .xfaTable .xfaRlRow > div {
  flex: 1;
}
.wy-content-pdf .xfaNonInteractive input,
.wy-content-pdf .xfaNonInteractive textarea,
.wy-content-pdf .xfaDisabled input,
.wy-content-pdf .xfaDisabled textarea,
.wy-content-pdf .xfaReadOnly input,
.wy-content-pdf .xfaReadOnly textarea {
  background: initial;
}
@media print {
  .wy-content-pdf .xfaTextfield,
  .wy-content-pdf .xfaSelect {
    background: transparent;
  }
  .wy-content-pdf .xfaSelect {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-indent: 1px;
    text-overflow: "";
  }
}
.wy-content-pdf [data-editor-rotation="90"] {
  transform: rotate(90deg);
}
.wy-content-pdf [data-editor-rotation="180"] {
  transform: rotate(180deg);
}
.wy-content-pdf [data-editor-rotation="270"] {
  transform: rotate(270deg);
}
.wy-content-pdf .annotationEditorLayer {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  font-size: calc(100px * var(--scale-factor));
  transform-origin: 0 0;
  cursor: auto;
  z-index: 20000;
}
.wy-content-pdf .annotationEditorLayer.freeTextEditing {
  cursor: var(--editorFreeText-editing-cursor);
}
.wy-content-pdf .annotationEditorLayer.inkEditing {
  cursor: var(--editorInk-editing-cursor);
}
.wy-content-pdf .annotationEditorLayer .selectedEditor {
  outline: var(--focus-outline);
  resize: none;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  padding: calc(var(--freetext-padding) * var(--scale-factor));
  resize: none;
  width: auto;
  height: auto;
  z-index: 1;
  transform-origin: 0 0;
  touch-action: none;
  cursor: auto;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal {
  background: transparent;
  border: none;
  top: 0;
  left: 0;
  overflow: visible;
  white-space: nowrap;
  resize: none;
  font: 10px sans-serif;
  line-height: var(--freetext-line-height);
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .overlay {
  position: absolute;
  display: none;
  background: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .overlay.enabled {
  display: block;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal:empty::before {
  content: attr(default-content);
  color: gray;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal:focus {
  outline: none;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.disabled {
  resize: none;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.disabled.selectedEditor {
  resize: horizontal;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor:hover:not(.selectedEditor),
.wy-content-pdf .annotationEditorLayer .inkEditor:hover:not(.selectedEditor) {
  outline: var(--hover-outline);
}
.wy-content-pdf .annotationEditorLayer .inkEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  overflow: auto;
  width: 100%;
  height: 100%;
  z-index: 1;
  transform-origin: 0 0;
  cursor: auto;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.editing {
  resize: none;
  cursor: inherit;
}
.wy-content-pdf .annotationEditorLayer .inkEditor .inkEditorCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  touch-action: none;
}
.wy-content-pdf [data-main-rotation="90"] {
  transform: rotate(90deg) translateY(-100%);
}
.wy-content-pdf [data-main-rotation="180"] {
  transform: rotate(180deg) translate(-100%, -100%);
}
.wy-content-pdf [data-main-rotation="270"] {
  transform: rotate(270deg) translateX(-100%);
}
.wy-content-pdf .pdfViewer {
  padding-bottom: var(--pdfViewer-padding-bottom);
}
.wy-content-pdf .pdfViewer .canvasWrapper {
  overflow: hidden;
}
.wy-content-pdf .pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: var(--page-margin);
  position: relative;
  overflow: visible;
  border: var(--page-border);
  -o-border-image: var(--page-border-image);
  border-image: var(--page-border-image);
  background-clip: content-box;
  background-color: rgb(255, 255, 255);
}
.wy-content-pdf .pdfViewer .dummyPage {
  position: relative;
  width: 0;
  height: var(--viewer-container-height);
}
.wy-content-pdf .pdfViewer.removePageBorders .page {
  margin: 0 auto 10px;
  border: none;
}
.wy-content-pdf .pdfViewer.singlePageView {
  display: inline-block;
}
.wy-content-pdf .pdfViewer.singlePageView .page {
  margin: 0;
  border: none;
}
.wy-content-pdf .pdfViewer.scrollHorizontal,
.wy-content-pdf .pdfViewer.scrollWrapped,
.wy-content-pdf .spread {
  margin-left: 3.5px;
  margin-right: 3.5px;
  text-align: center;
}
.wy-content-pdf .pdfViewer.scrollHorizontal,
.wy-content-pdf .spread {
  white-space: nowrap;
}
.wy-content-pdf .pdfViewer.removePageBorders,
.wy-content-pdf .pdfViewer.scrollHorizontal .spread,
.wy-content-pdf .pdfViewer.scrollWrapped .spread {
  margin-left: 0;
  margin-right: 0;
}
.wy-content-pdf .spread .page,
.wy-content-pdf .spread .dummyPage,
.wy-content-pdf .pdfViewer.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.scrollWrapped .page,
.wy-content-pdf .pdfViewer.scrollHorizontal .spread,
.wy-content-pdf .pdfViewer.scrollWrapped .spread {
  display: inline-block;
  vertical-align: middle;
}
.wy-content-pdf .spread .page,
.wy-content-pdf .pdfViewer.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.scrollWrapped .page {
  margin-left: var(--spreadHorizontalWrapped-margin-LR);
  margin-right: var(--spreadHorizontalWrapped-margin-LR);
}
.wy-content-pdf .pdfViewer.removePageBorders .spread .page,
.wy-content-pdf .pdfViewer.removePageBorders.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.removePageBorders.scrollWrapped .page {
  margin-left: 5px;
  margin-right: 5px;
}
.wy-content-pdf .pdfViewer .page canvas {
  margin: 0;
  display: block;
}
.wy-content-pdf .pdfViewer .page canvas[hidden] {
  display: none;
}
.wy-content-pdf .pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.wy-content-pdf .pdfViewer .page .loadingIcon.notVisible {
  background: none;
}
.wy-content-pdf .pdfViewer.enablePermissions .textLayer span {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  user-select: none !important;
  cursor: not-allowed;
}
.wy-content-pdf .pdfPresentationMode .pdfViewer {
  padding-bottom: 0;
}
.wy-content-pdf .pdfPresentationMode .spread {
  margin: 0;
}
.wy-content-pdf .pdfPresentationMode .pdfViewer .page {
  margin: 0 auto;
  border: 2px solid transparent;
}
.wy-content-pdf .pdfViewer .page {
  box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
  background-color: var(--wy-white, var(, ));
}

.wy-content-text {
  word-break: break-word;
  white-space: pre-wrap;
}

.wy-likes {
  display: inline-flex;
  align-items: center;
}

.wy-like-button {
  background: var(--wy-component-background-color);
  color: var(--wy-primary);
  width: 2.5rem;
  height: 2.5rem;
}

.wy-like-count {
  padding: 0 0.5rem;
  color: var(--wy-outline);
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-reaction-count {
  margin: 0 0.5rem 0 0.125rem;
  line-height: 1;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-reaction-menu {
  padding: 0.25rem;
  font-size: 1.125rem;
  border-radius: 2.5rem;
}

.wy-reaction-picker {
  display: flex;
}
.wy-reaction-picker .wy-reaction-button {
  color: unset;
}

.wy-reactions {
  display: inline-flex;
  align-items: center;
  column-gap: 0.1875rem;
}
.wy-reactions:empty {
  display: none;
}

.wy-reactions-line {
  display: flex;
  align-items: center;
}

:host(wy-reactions) .wy-emoji {
  width: 1.125rem;
  height: 1.125rem;
  font-size: 1.125rem;
}
:host(wy-reactions) .wy-emoji:first-child {
  margin-left: 0.1875rem;
}
:host(wy-reactions) .wy-emoji:last-child {
  margin-right: 0.1875rem;
}

:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji {
  width: 1.125rem;
  height: 1.125rem;
  font-size: 1rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji:first-child, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji:first-child {
  margin-left: 0.125rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji:last-child, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji:last-child {
  margin-right: 0.125rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-like-count, :host(wy-reactions[small]) .wy-reaction-like-button .wy-like-count {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
}

.wy-table-reactions td:first-child {
  width: 3rem;
}
.wy-table-reactions td:nth-child(2) {
  width: 100%;
}
.wy-table-reactions tr:last-child td {
  box-shadow: none;
}

.wy-reaction {
  font-size: 1.125rem;
}

.wy-reaction-menu-button, .wy-like-button {
  background: var(--wy-component-background-color);
  color: currentColor;
  border-radius: var(--wy-border-radius-pill, 50rem);
  background-clip: content-box;
}

.wy-sheet {
  --wy-scrollbar-adjust-top: 0;
  --wy-scrollbar-adjust-bottom: 0;
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  position: fixed;
  z-index: 1055;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  max-height: max(50vh, 50%);
  min-height: 3rem;
  margin: 0.5rem auto;
  max-width: 32rem;
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
}
.wy-sheet > .wy-appbars, .wy-sheet > .wy-appbar {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.wy-sheet-body {
  overflow: hidden;
  padding: 0.5rem;
  position: relative;
  min-height: 3rem;
}
.wy-sheet-body.wy-scroll-y {
  overflow-y: auto;
}

.wy-sheet:not(.wy-show) {
  opacity: 0;
  transform: translateY(32rem);
}
.wy-sheet.wy-show {
  opacity: 1;
  transform: none;
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  pointer-events: auto;
}

.wy-spinner {
  align-self: center;
  justify-self: center;
  margin: auto;
}
.wy-spinner circle {
  stroke-dasharray: 1, 100;
  stroke-dashoffset: 0;
  transform-origin: center;
  fill: none !important;
}
.wy-spinner.wy-spin {
  animation: wy-rotate 1.4s linear infinite;
}
.wy-spinner.wy-spin circle {
  animation: wy-dash 1.4s ease-in-out infinite, wy-color 2.8s ease-in-out infinite;
}
.wy-spinner.wy-spinner-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

@keyframes wy-rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes wy-dash {
  0% {
    stroke-dasharray: 1, 100;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 44.5, 100;
    stroke-dashoffset: -17.5;
  }
  100% {
    stroke-dasharray: 44.5, 100;
    stroke-dashoffset: -62;
  }
}
@keyframes wy-color {
  0%, 100% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
  25% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
  50% {
    stroke: transparent;
  }
  75% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
}
.wy-toasts {
  position: fixed;
  left: 0;
  bottom: 3.5rem;
  right: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1030;
  gap: 1rem;
}

.wy-toast {
  background: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  margin: 0 0 1rem;
  width: 16rem;
  max-width: calc(100% - 3rem);
  gap: 0.5rem;
  display: flex;
  cursor: pointer;
  border-radius: var(--wy-border-radius, 0.5rem);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.75rem;
  user-select: none;
  box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
  position: relative;
  overflow: hidden;
  height: auto;
}
.wy-toast.wy-fade {
  transition: all var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
}
.wy-toast.wy-fade:not(.wy-show) {
  opacity: 0;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.wy-toast-action {
  position: sticky;
  top: 4.5rem;
  bottom: 4.5rem;
  z-index: 990;
  background-color: var(--wy-primary, var(--wy-primary-40, #006399));
  color: var(--wy-on-primary, var(--wy-white, #ffffff));
  padding: 0.5rem 1rem;
  border-radius: var(--wy-border-radius-pill, 50rem);
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  width: max-content;
  align-self: center;
  text-align: center;
  box-shadow: none;
}

.wy-toast-primary {
  background: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
}

.wy-typing-show {
  font-style: italic;
  display: none;
}

.wy-typing-active .wy-typing-show {
  display: block;
}
.wy-typing-active .wy-typing-hide {
  display: none;
}

.wy-appbar wy-typing {
  position: relative;
  padding: 0 1.25rem;
}

.wy-placeholder {
  cursor: wait;
  color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  background: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 0.5;
  animation: wy-placeholder-glow 2s ease-in-out infinite;
}

@keyframes wy-placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.wy-meeting {
  flex: 1 1 100%;
  align-items: flex-start;
}

.wy-meeting-actions {
  margin-top: 0.5rem;
}

.wy-dragging::after {
  content: attr(data-drag-title);
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--wy-primary, var(--wy-primary-40, #006399));
  font-weight: 700;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/*
.wy-message-editor {
  background-color: color.token(--wy-surface-1);
}
*/
.wy-message-editor-top {
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
@supports (position: sticky) {
  .wy-message-editor-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.wy-message-editor-bottom {
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
@supports (position: sticky) {
  .wy-message-editor-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

.wy-message-form .wy-spinner {
  display: none;
}
.wy-message-form.wy-uploading .wy-spinner {
  display: block;
}
.wy-message-form.wy-uploading [data-icon=plus] {
  display: none;
}
.wy-message-form .wy-picker-list:not(:empty) {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-message-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0.5rem 0.25rem;
  min-height: 3.5rem;
}
.wy-message-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}

.wy-message-editor-buttons {
  flex: 1 0 auto;
}

.wy-message-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-message-editor-mention {
  background: blue;
  color: white;
}

.wy-message-editor-link {
  background: blue;
  color: white;
}

.wy-message-editor .ͼ1.cm-editor,
.wy-message-editor-grow::after,
.wy-message-editor-grow > textarea,
.wy-message-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: 1.25rem;
  border: var(--wy-input-border-width, 1px) solid var(--wy-background, var(--wy-neutral-99, #fcfcff));
}
.wy-message-editor .ͼ1.cm-editor:focus,
.wy-message-editor-grow:focus::after,
.wy-message-editor-grow > textarea:focus,
.wy-message-editor-textfield:focus {
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-message-editor .ͼ1.cm-editor .cm-content,
.wy-message-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)),  inherit;
  font-size: var(--wy-font-size-base, 1rem);
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-message-editor-grow {
  display: grid;
}
.wy-message-editor-grow::after,
.wy-message-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-message-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-message-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-message-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-message-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-message-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-message-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-message-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  outline: 0;
}
.wy-message-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-message-editor .wy-is-invalid + [data-editor-target] .cm-editor, .wy-message-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-message-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-message-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-message-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-message-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-message-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-message-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-message-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-message-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-messenger-conversation {
  ---background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  ---color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(---background-color);
  color: var(---color);
  overflow-anchor: none;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 100%;
}

.wy-card {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-border-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: var(--wy-component-border-radius);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
}
.wy-card > hr {
  margin-right: 0;
  margin-left: 0;
}

.wy-card-primary {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
}

.wy-card-hover {
  cursor: pointer;
  user-select: none;
}
.wy-card-hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: var(--wy-component-color);
  opacity: 0%;
}
.wy-card-hover:hover::before {
  opacity: var(--wy-opacity-state-hover, 8%);
}
.wy-card-hover:focus::before {
  opacity: var(--wy-opacity-state-focus, 12%);
}
.wy-card-hover:active::before, .wy-card-hover.wy-active::before {
  opacity: var(--wy-opacity-state-active, 12%);
}

.wy-card-actions {
  position: absolute;
  top: min(0.25rem, 100% - 2.5rem);
  right: 0.25rem;
  align-items: center;
  display: flex;
}
.wy-card-actions > .wy-button-icon, .wy-card-actions > .wy-dropdown > .wy-button-icon {
  background-clip: content-box;
}

.wy-card-content {
  flex: 1 0 auto;
  padding-block-end: 0.5rem;
  padding-inline-start: 0.5rem;
  padding-inline-end: 0.5rem;
}
.wy-card-content:first-child, .wy-card-actions + .wy-card-content:nth-child(2) {
  padding-block-start: 0.5rem;
}

.wy-card-top {
  border-radius: var(--wy-component-border-radius);
  object-fit: cover;
  object-position: top center;
  flex: 1 1 100%;
  max-height: 10rem;
}

.wy-card-top-image {
  object-position: 50% 38%;
}

.wy-card-trashed {
  text-decoration: line-through;
}
.wy-card-trashed > *:not(.wy-card-actions) {
  opacity: var(--wy-opacity-disabled, 38%);
}

.wy-filename {
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.wy-files {
  width: 100%;
  height: 100%;
  position: relative;
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  display: flex;
  flex-direction: column;
  flex: 1;
}

@supports (position: sticky) {
  wy-files-appbar {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.wy-table-files thead {
  display: none;
  text-align: left;
}
.wy-table-files td:nth-child(2) {
  padding: 0 var(--wy-table-cell-padding-x, 0.25rem);
}
.wy-table-files td:nth-child(2),
.wy-table-files th:nth-child(2) {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(3),
.wy-table-files th:nth-child(3) {
  display: none;
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(4),
.wy-table-files th:nth-child(4) {
  display: none;
  width: 7.5rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(5),
.wy-table-files th:nth-child(5) {
  display: none;
  width: 7rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 576px) {
  .wy-table-files thead {
    display: table-header-group;
  }
  .wy-table-files td:nth-child(5),
  .wy-table-files th:nth-child(5) {
    display: table-cell;
  }
}
@media (min-width: 768px) {
  .wy-table-files td:nth-child(3),
  .wy-table-files th:nth-child(3),
  .wy-table-files td:nth-child(4),
  .wy-table-files th:nth-child(4) {
    display: table-cell;
  }
}

.wy-files-thead {
  text-align: left;
}
@media (max-width: 767.98px) {
  .wy-files-thead {
    display: none;
  }
}

.wy-files-td-filename {
  padding: 0 var(--wy-table-cell-padding-x, 0.25rem);
}

.wy-files-td-filename,
.wy-files-th-filename {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-files-td-modified,
.wy-files-th-modified {
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 991.98px) {
  .wy-files-td-modified,
  .wy-files-th-modified {
    display: none;
  }
}

.wy-files-td-kind,
.wy-files-th-kind {
  width: 7.5rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 991.98px) {
  .wy-files-td-kind,
  .wy-files-th-kind {
    display: none;
  }
}

.wy-files-td-size,
.wy-files-th-size {
  width: 7rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 768px) {
  .wy-files-td-size,
  .wy-files-th-size {
    display: none;
  }
}

.wy-grid {
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
  grid-gap: 0.75rem;
}

.wy-sidebar {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  min-width: 0;
  min-height: 0;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 18rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  transition: flex-basis var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  position: relative;
  order: 9999;
}
.wy-sidebar > * {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) calc(var(--wy-transition-duration, 0.2s) - var(--wy-transition-duration-fast, 0.1s));
  min-width: 18rem;
}
.wy-sidebar[hidden] {
  display: flex !important;
  flex-basis: 0;
}
.wy-sidebar[hidden] > * {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  opacity: 0;
}
@media (min-width: 768px) {
  .wy-sidebar > * {
    min-width: 18rem;
  }
  .wy-sidebar .wy-sidebar-handle {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .wy-sidebar {
    transition: flex-basis var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), margin-top var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
    border-top-left-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
    border-top-right-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
    flex-basis: 50vh;
  }
  .wy-sidebar:not([hidden]) {
    margin-top: calc(-1 * var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  }
  .wy-sidebar:not([hidden]).wy-maximized {
    flex-basis: calc(100% - var(--wy-appbar-height, 3rem) * .5);
    margin-top: calc(-50% + var(--wy-appbar-height, 3rem) * 2.5 - var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  }
  .wy-sidebar:not([hidden]).wy-maximized ~ * .wy-nav-prev,
  .wy-sidebar:not([hidden]).wy-maximized ~ * .wy-nav-next {
    display: none;
  }
  .wy-sidebar > * {
    min-height: var(--wy-appbar-height, 3rem);
  }
}

.wy-sidebar-handle {
  width: 4rem;
  background-clip: content-box;
  background-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  height: 1rem;
  border: 0.375rem solid transparent;
  position: absolute;
  top: 0rem;
  z-index: 2;
  left: 50%;
  margin-left: -2rem;
  border-radius: var(--wy-border-radius-pill, 50rem);
  cursor: pointer;
}

.wy-table {
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  table-layout: fixed;
  width: 100%;
  vertical-align: top;
  border-collapse: collapse;
}
.wy-table th, .wy-table td {
  padding: var(--wy-table-cell-padding-y, 0.25rem) var(--wy-table-cell-padding-x, 0.25rem);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
  line-height: 1;
  vertical-align: middle;
  height: 2.5rem;
}
.wy-table th:first-child, .wy-table td:first-child {
  padding-left: calc(var(--wy-table-cell-padding-x, 0.25rem) * 2);
}
.wy-table th:last-child, .wy-table td:last-child {
  padding-right: calc(var(--wy-table-cell-padding-x, 0.25rem) * 2);
}
.wy-table > tbody {
  vertical-align: inherit;
}
.wy-table > thead {
  vertical-align: bottom;
}
.wy-table .wy-table-cell-icon {
  color: var(--wy-component-color);
  vertical-align: middle;
  text-align: center;
  padding: calc(var(--wy-table-cell-padding-y, 0.25rem) * .5) var(--wy-table-cell-padding-x, 0.25rem);
  width: calc(2.5rem + var(--wy-table-cell-padding-x, 0.25rem) * 2);
  font-size: var(--wy-font-size-base, 1rem);
  font-weight: var(--wy-font-weight-base, );
  text-transform: none;
  letter-spacing: normal;
}
.wy-table .wy-table-cell-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.wy-table-hover > tbody > tr:not(.wy-pager):hover > * {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--color);
  background-color: var(--wy-component-background-color);
  cursor: pointer;
}

.wy-table-trashed th, .wy-table-trashed td {
  text-decoration: line-through;
}
.wy-table-trashed th:not(:last-child) > *, .wy-table-trashed td:not(:last-child) > * {
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-table-trashed th > a, .wy-table-trashed td > a {
  color: var(--wy-component-color);
}
.wy-table-trashed:hover th, .wy-table-trashed:hover td {
  opacity: 1;
}

.wy-table-no-result {
  text-align: center;
  padding: 1rem;
}

.wy-table-sort-link {
  display: inline-flex;
  align-items: center;
  color: var(--wy-link, var(--wy-primary-40, #006399));
  cursor: pointer;
}

.wy-post {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 1rem 0.75rem;
  --wy-component-border-radius: var(--wy-border-radius, 0.5rem);
  border-radius: var(--wy-component-border-radius);
}
.wy-post .wy-image-grid {
  border-radius: 0;
  margin-bottom: 1rem;
}
.wy-post .wy-embed {
  margin-bottom: 1rem;
}
.wy-post .wy-comments {
  margin: 0.5rem 0.75rem;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  padding: 0.75rem 0 0;
}

.wy-post-body {
  padding: 0 1rem;
}
.wy-post-body:empty {
  display: none;
}
.wy-post-body .wy-content, .wy-post-body .wy-list, .wy-post-body .wy-poll {
  margin-bottom: 1rem;
}

.wy-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.25rem 0.25rem;
}
.wy-post-footer .wy-meta {
  margin-right: 0.5rem;
}

.wy-post-dragging::after {
  content: attr(data-drag-title, "Drop files here to upload.");
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--wy-primary, var(--wy-primary-40, #006399));
  font-weight: 700;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.wy-poll {
  flex: 1 1 100%;
  min-width: 0;
}

.wy-poll-form {
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  padding: 0.5rem;
}
.wy-poll-form:empty {
  display: none;
}
.wy-poll-form input:not(:first-child) {
  margin-top: 0.5rem;
}

.wy-poll-option {
  position: relative;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  margin-bottom: 0.25rem;
  padding: 0.25rem 0.5rem;
  min-height: 2.5rem;
  cursor: pointer;
}
.wy-poll-option .wy-progress {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
}
.wy-poll-option > :not(.wy-progress) {
  z-index: 1;
}

.wy-embed {
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
}

.wy-embed-photo a {
  display: flex;
}
.wy-embed-photo img {
  width: 100%;
  height: auto;
}

.wy-embed-photo-sm a {
  padding: 0 1rem;
}
.wy-embed-photo-sm img {
  display: block;
  margin: 0 auto;
  width: auto;
  max-width: 100%;
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
}

.wy-embed-video {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.wy-embed-video::before {
  display: block;
  content: "";
  padding-top: 56.25%;
}
.wy-embed-video iframe, .wy-embed-video embed, .wy-embed-video object, .wy-embed-video video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.wy-embed-caption {
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  padding: 0.5rem 1rem 1rem;
  position: relative;
}

.wy-embed-link {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  text-transform: uppercase;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}
.wy-embed-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.wy-embed-title {
  font-weight: var(--wy-headings-font-weight, 500);
  margin-bottom: 0.5rem;
}

.wy-embed-description {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}

.wy-embed-preview a[target=_blank] {
  pointer-events: none;
}
.wy-embed-preview .wy-embed {
  display: none;
  margin: 0.75rem;
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-radius: var(--wy-border-radius, 0.5rem);
}
.wy-embed-preview .wy-embed:first-child {
  display: block;
}
.wy-embed-preview .wy-embed-caption {
  border-bottom-left-radius: var(--wy-border-radius, 0.5rem);
  border-bottom-right-radius: var(--wy-border-radius, 0.5rem);
}
.wy-embed-preview .wy-embed-actions {
  display: flex;
}

.wy-embed-actions {
  display: none;
  justify-content: space-between;
  padding: 0.5rem 0.25rem;
}

.wy-embed-cycle {
  visibility: hidden;
}
.wy-embed-show-cycle .wy-embed-cycle {
  visibility: visible;
}

.wy-post-editor {
  padding: 0.75rem;
}
.wy-post-editor.wy-uploading .wy-icon-active-stack > :first-child {
  opacity: 0;
}
.wy-post-editor.wy-uploading .wy-icon-active-stack > :last-child {
  opacity: 1;
}
.wy-post-editor .wy-picker-list:not(:empty) {
  margin-top: 0.75rem;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-post-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: 3.5rem;
  flex-wrap: wrap;
}
.wy-post-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}
.wy-post-editor-inputs > :last-child {
  margin-left: auto;
}

.wy-post-editor-buttons {
  flex: 1 0 auto;
}

.wy-post-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-post-editor-mention {
  background: blue;
  color: white;
}

.wy-post-editor-link {
  background: blue;
  color: white;
}

.wy-post-editor .ͼ1.cm-editor,
.wy-post-editor-grow::after,
.wy-post-editor-grow > textarea,
.wy-post-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  min-height: 4rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  caret-color: var(--wy-primary, var(--wy-primary-40, #006399));
}
.wy-post-editor .ͼ1.cm-editor:focus,
.wy-post-editor-grow:focus::after,
.wy-post-editor-grow > textarea:focus,
.wy-post-editor-textfield:focus {
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-post-editor .ͼ1.cm-editor .cm-content,
.wy-post-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-post-editor-grow {
  display: grid;
}
.wy-post-editor-grow::after,
.wy-post-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-post-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-post-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-post-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-post-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-post-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-post-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-post-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-post-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-post-editor .wy-is-invalid + [data-editor-target] .cm-editor, .wy-post-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-post-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-post-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-post-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-post-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-post-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-post-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-post-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-post-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-comments {
  padding: 0 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.wy-comments-count {
  padding: 0 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-comment {
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-border-radius: var(--wy-border-radius, 0.5rem);
  border-radius: var(--wy-component-border-radius);
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem;
  position: relative;
}
.wy-comment .wy-item {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.wy-comment .wy-item > .wy-avatar, .wy-comment .wy-item > wy-icon, .wy-comment .wy-item > .wy-icon-stack {
  margin-left: -0.25rem;
}
.wy-comment .wy-reactions-line {
  position: absolute;
  bottom: -1.125rem;
  right: 0.25rem;
}

.wy-comment-body {
  flex: 1 0 auto;
  z-index: 1;
}
.wy-comment-body .wy-image-grid, .wy-comment-body .wy-embed, .wy-comment-body .wy-content, .wy-comment-body .wy-list, .wy-comment-body .wy-poll {
  margin-bottom: 1rem;
}
.wy-comment-body .wy-image-grid:last-child, .wy-comment-body .wy-embed:last-child, .wy-comment-body .wy-content:last-child, .wy-comment-body .wy-list:last-child, .wy-comment-body .wy-poll:last-child {
  margin-bottom: 0;
}

.wy-comment-content {
  padding: 0 0.5rem 0.5rem;
  display: flex;
  flex-direction: column;
}

.wy-comment-editor .wy-spinner {
  display: none;
}
.wy-comment-editor.wy-uploading .wy-spinner {
  display: block;
}
.wy-comment-editor.wy-uploading [data-icon=plus] {
  display: none;
}
.wy-comment-editor .wy-picker-list:not(:empty) {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-comment-editor-bottom {
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}

.wy-comment-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0.5rem 0.25rem;
  min-height: 3.5rem;
}
.wy-comment-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}

.wy-comment-editor-buttons {
  flex: 1 0 auto;
}

.wy-comment-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-comment-editor-mention {
  background: blue;
  color: white;
}

.wy-comment-editor-link {
  background: blue;
  color: white;
}

.wy-comment-editor .ͼ1.cm-editor,
.wy-comment-editor-grow::after,
.wy-comment-editor-grow > textarea,
.wy-comment-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: 1.25rem;
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}
.wy-comment-editor .ͼ1.cm-editor:focus,
.wy-comment-editor-grow:focus::after,
.wy-comment-editor-grow > textarea:focus,
.wy-comment-editor-textfield:focus {
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-comment-editor .ͼ1.cm-editor .cm-content,
.wy-comment-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-comment-editor-grow {
  display: grid;
}
.wy-comment-editor-grow::after,
.wy-comment-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-comment-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-comment-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-comment-editor {
  position: relative;
}
.wy-comment-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-comment-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-comment-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-comment-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-comment-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-comment-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-comment-editor .wy-is-invalid + .cm-editor, .wy-comment-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-comment-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-comment-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-comment-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-comment-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-comment-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-comment-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-comment-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-comment-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: var(--wy-font-weight-bold, );
  line-height: 1;
  color: var(--wy-on-primary, var(--wy-white, #ffffff));
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--wy-border-radius-pill, 50rem);
  background-color: var(--wy-primary, var(--wy-primary-40, #006399));
}
.wy-badge:empty {
  display: none;
}

.wy-button {
  position: relative;
}
.wy-button .wy-badge {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 1rem;
  margin: 0;
  padding: 0.25rem;
  min-width: 1rem;
  max-width: 2rem;
  height: 1rem;
  line-height: 0.5rem;
  display: block;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-button .wy-badge:empty {
  display: none;
}

.wy-conversations {
  position: relative;
}

.wy-conversation {
  display: flex;
  position: relative;
}
.wy-conversation .wy-item-title {
  font-weight: 400;
}
.wy-conversation.wy-unread .wy-item-title {
  font-weight: 700;
}
.wy-conversation.wy-unread .wy-item-text, .wy-conversation.wy-unread .wy-meta {
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  font-weight: 600;
}
.wy-conversation .wy-item-text .wy-typing-show {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

.wy-messenger-conversation {
  ---background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  ---color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(---background-color);
  color: var(---color);
  overflow-anchor: none;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
